import React, { useEffect, useMemo, useState } from "react";
import objectPath from "object-path";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { UserNotificationsDropdown } from "../extras/dropdowns/UserNotificationsDropdown";
import { SearchDropdown } from "../extras/dropdowns/search/SearchDropdown";
import { QuickUserToggler } from "../extras/QuiclUserToggler";
import MultiLingual from "../extras/dropdowns/MultiLingual";
import MultiCurrency from "../extras/dropdowns/MultiCurrency";
import { makeStyles } from "@material-ui/core";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import { NODE_API_URL, BASE_URL, CCMODE_BASE_URL } from "./../../../../env_config";
import Cookies from "js-cookie";
import { ReactComponent as CCModeLogo } from "./../../../../assets/images/ccmode_logo.svg";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    ccmodeBtn: {
        height: 29,
        borderRadius: 25,
        outline: "none !important",
        border: "1px solid #424242",
        color: "#424242 !important",
        fontWeight: 500,
        textTransform: "uppercase",
        display: "flex",
        alignItems: "center",
        gap: 8,
        paddingRight: 4,
        paddingLeft: 4,
        transition: "all 0.5s ease",

        "& span": {
            display: "none",
        },

        "&:hover": {
            paddingLeft: 10,
            "& span": {
                display: "inline",
            },
        },

        [theme.breakpoints.down("sm")]: {
            paddingLeft: 10,
            "& span": {
                display: "inline",
            },
        },
    },
}));

export function Topbar(props) {
    const classes = useStyles();
    const uiService = useHtmlClassService();

    const history = useHistory();

    const [ccmodedata, setCCModeData] = useState();
    const [ccmodesetting, setCCModeSetting] = useState();

    const layoutProps = useMemo(() => {
        return {
            viewNotificationsDisplay: objectPath.get(
                uiService.config,
                "extras.notifications.display"
            ),
            viewQuickActionsDisplay: objectPath.get(
                uiService.config,
                "extras.quick-actions.display"
            ),
            viewCartDisplay: objectPath.get(
                uiService.config,
                "extras.cart.display"
            ),
            viewUserDisplay: objectPath.get(
                uiService.config,
                "extras.user.display"
            ),
            viewSearchDisplay: objectPath.get(
                uiService.config,
                "extras.search.display"
            ),
            // viewQuickPanelDisplay: objectPath.get(uiService.config,"extras.quick-panel.display"),
        };
    }, [uiService]);

    async function handleCCModeBtn() {
        if(ccmodedata && ccmodedata.Status === 2 && ccmodesetting){
            try {
            const res = await axios({
                method: "GET",
                url: `${NODE_API_URL}/INTL/generate-auto-login-token`,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
                },
            });

            if (res && res.data && res.data.success) {
                const token = res.data.token;
                const clientURL = `${ccmodesetting[0].client_domain || CCMODE_BASE_URL}?autoLoginToken=${encodeURIComponent(
                    token
                )}`;
                window.open(clientURL, "_blank");
            }
            } catch (error) {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }
                    window.location.replace(`${BASE_URL}/logout`);
                }
            }
        } else{
            history.push("/ccmode");
        }
    }

    useEffect(() => {
        axios({
            method: "GET",
            url: `${NODE_API_URL}/INTL/fetch-ccmode`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
        })
            .then((res) => {
                if (res && res.data && res.data.data) {
                    setCCModeData(res.data.data);
                }
            })
            .catch((error) => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
            });

        axios({
            method: "get",
            url: `${NODE_API_URL}/INTL/fetch-ccmode-setting-data`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
        })
            .then((res) => {
                if (res && res.data && res.data.data && res.data.data.length) {
                    setCCModeSetting(res.data.data);
                }
            })
            .catch((error) => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
            });
    }, []);

    return (
        <div className="topbar">
            <div className="d-flex d-md-none">
                {layoutProps.viewSearchDisplay && <SearchDropdown {...props} />}
            </div>
            <div className="align-items-center d-flex justify-content-end w-100px">
                <OverlayTrigger
                    placement="bottom"
                    overlay={
                        <Tooltip id="tooltip">Open CCMode Portal</Tooltip>
                    }
                >
                    <div className={`${classes.ccmodeBtn} cursor-pointer`}  onClick={() => handleCCModeBtn()}>
                        <span>ccmode</span>
                        <CCModeLogo
                            className="cursor-pointer"
                            style={{ width: 24 }}
                        />
                    </div>
                </OverlayTrigger>
            </div>
            <div className="align-items-center d-flex">
                <MultiLingual />
            </div>
            <MultiCurrency {...props} />
            {/* {layoutProps.viewQuickPanelDisplay && (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="quick-panel-tooltip">Quick panel</Tooltip>}
        >
          <div
            className="topbar-item"
            data-toggle="tooltip"
            title="Quick panel"
            data-placement="right"
          >
            <div
              className="btn btn-icon btn-clean btn-lg mr-1"
              id="kt_quick_panel_toggle"
            >
              <span className="svg-icon svg-icon-xl svg-icon-primary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Layout/Layout-4-blocks.svg"
                  )}
                />
              </span>
            </div>
          </div>
        </OverlayTrigger>
      )} */}
            {layoutProps.viewNotificationsDisplay && (
                <UserNotificationsDropdown
                    language={props.language}
                    userinfo={props.userinfo}
                />
            )}
            {/* {layoutProps.viewQuickActionsDisplay && <QuickActionsDropdown />}
      {layoutProps.viewCartDisplay && <MyCartDropdown />} */}
            {layoutProps.viewUserDisplay && (
                <QuickUserToggler
                    language={props.language}
                    userinfo={props.userinfo}
                />
            )}
        </div>
    );
}
